import React from "react";
import { useNavigate } from "react-router";
import { SelectionLayoutProps } from "@companion-core/shared/app/Interfaces/blocks";
import { useDynamicPageStore } from "@companion-core/shared/app/Store/dynamicPageStore";
import { Button } from "@companion-core/shared/app/Components/Button";
import { ComponentCard } from "@companion-core/shared/app/Components/Cards/ComponentCard";
import { useMediaQuery } from "@companion-core/web/src/Utilities/mediaQuery";
import { redirectTo } from "@companion-core/web/src/Utilities/navigation";
import "@companion-core/web/src/Assets/Styles/scss/selectionCommonLayout.scss";

export const SelectionCommonLayout = ({
  text,
  cardList,
  button,
  blockSlug,
}: SelectionLayoutProps) => {
  const { pageSlug } = useDynamicPageStore();
  const navigate = useNavigate();
  const isMobileSize = useMediaQuery("(max-width: 768px)");

  return (
    isMobileSize && (
      <section
        className="selection-common-layout"
        data-testid={`selection-common-layout-${blockSlug}`}>
        {text && (
          <h2
            data-testid={`selection-common-layout__title-${blockSlug}`}
            className="selection-common-layout__title super-title-3">
            {text.title}
          </h2>
        )}
        <div
          data-testid={`selection-common-layout__cards-${blockSlug}`}
          className={`selection-common-layout__cards ${
            cardList.length > 1 ? "selection-common-layout__cards--multiple" : ""
          }`}>
          {cardList?.map((component, index) => {
            return (
              <ComponentCard
                key={`selection-common-layout-card-${component.id}`}
                component={component}
                pageSlug={pageSlug ?? ""}
                nbItems={cardList.length}
                position={index}
                url={window.location.href}
              />
            );
          })}
        </div>
        {button && button.button_title && (
          <Button
            testID={`selection-common-layout__cta-${blockSlug}`}
            classNames={["selection-common-layout__cta"]}
            label={button.button_title}
            size="large"
            onClick={() =>
              redirectTo(button.button_link ?? "/", button?.button_type ?? "internal", navigate)
            }
          />
        )}
      </section>
    )
  );
};
